const hasStorage = () => typeof window !== 'undefined' && window.localStorage;

export const languages = {
  Pt: {
    theme_label: 'Tema',
    language_label: 'Idioma',
    theme_light: 'Claro',
    theme_dark: 'Escuro',
    login_welcome: 'Bem-vindo',
    login_subtitle: 'Faça login para continuar.',
    email: 'E-mail',
    credential_placeholder: 'E-mail ou CPF',
    password: 'Senha',
    password_placeholder: 'Digite sua senha',
    enter: 'Entrar',
    login_hero_brand: 'CORREÇÃO ONTEST',
    login_hero_title: 'Corrija redações e questões com foco, clareza e rastreabilidade.',
    login_hero_text: 'Organize critérios, notas, comentários e pendências em um ambiente feito para correção acadêmica.',
    correction_brand: 'Correção OnTest',
    select_institution_title: 'Escolha onde registrar suas correções',
    select_institution_subtitle: 'Entre na instituição para revisar redações, avaliar questões dissertativas e lançar notas com segurança.',
    access_correction_room: 'Acessar ambiente de correção',
    access: 'Acessar',
    no_institution_available: 'Nenhuma instituição disponível no momento.',
    breadcrumb_home: 'Início',
    breadcrumb_processes: 'Lista de Processos',
    breadcrumb_modules: 'Módulos',
    breadcrumb_essays: 'Redações',
    breadcrumb_corrected_essay: 'Redação corrigida',
    breadcrumb_discursive: 'Questões dissertativas',
    breadcrumb_discursive_corrected: 'Dissertativas corrigidas',
    breadcrumb_profile: 'Perfil',
    corrector_area: 'Área do corretor',
    correction_panel: 'Painel de correção',
    corrector_name: 'Nome do Corretor',
    selective_processes: 'Processos seletivos',
    process_list: 'Lista de Processos',
    linked_processes: 'Aqui são listados todos os processos seletivos que você está vinculado',
    process_singular: 'processo',
    process_plural: 'processos',
    filter_all: 'Todos',
    filter_active: 'Ativos',
    filter_scheduled: 'Agendados',
    filter_closed: 'Encerrados',
    status_active: 'Ativo',
    status_scheduled: 'Agendado',
    status_closed: 'Encerrado',
    open_process_modules: 'Abrir salas, redações e questões deste processo',
    no_process_linked: 'Você não está vinculado a nenhum processo seletivo',
    no_process_status: 'Nenhum processo encontrado para este status',
    selective_process: 'Processo seletivo',
    back: 'Voltar',
    start_time: 'Hora de início',
    end_time: 'Hora de encerramento',
    pending_essays: 'Redações Pendentes',
    pending_essays_desc: 'Salas com redações aguardando correção',
    corrected_essays: 'Redações Corrigidas',
    corrected_essays_desc: 'Histórico das correções já finalizadas',
    discursive_questions: 'Questões Dissertativas',
    discursive_questions_desc: 'Respostas discursivas pendentes',
    corrected_discursive: 'Dissertativas Corrigidas',
    corrected_discursive_desc: 'Respostas discursivas finalizadas',
    room: 'Sala',
    corrected_count_text: '{corrected} de {total} redações corrigidas',
    no_room_available: 'Nenhuma sala disponível para correção',
    open: 'Abrir',
    review: 'Revisar',
    correct: 'Corrigir',
    search_candidate_placeholder: 'Pesquisar pelo número de inscrição do candidato',
    search: 'Buscar',
    no_essay_found: 'Nenhuma redação encontrada',
    no_discursive_found: 'Nenhuma questão dissertativa encontrada',
    registration: 'Inscrição',
    question: 'Questão',
    question_number: 'Questão Número',
    corrected_on: 'Corrigida em',
    score: 'Nota',
    general_score: 'Nota Geral',
    title: 'Título',
    prompt: 'Enunciado',
    criteria: 'Critérios',
    code: 'CÓD.',
    criteria_label: 'CRITÉRIOS',
    max_score: 'NOTA MÁXIMA',
    obtained_score: 'NOTA OBTIDA',
    final_score: 'Nota final',
    comment: 'Comentário',
    general_comment: 'Comentário Geral',
    markings: 'Marcações',
    candidate: 'Candidato',
    number: 'Número',
    aspects: 'Aspectos',
    essay_counter: 'Redações {current} de {total}',
    zero_score: 'NOTA ZERO',
    loading_data: 'Carregando dados. Por favor, aguarde.',
    loading_hint: 'Aguarde enquanto preparamos as informações.',
    communication_placeholder: 'Escreva um comunicado geral para enviar aos candidatos',
  },
  En: {
    theme_label: 'Theme',
    language_label: 'Language',
    theme_light: 'Light',
    theme_dark: 'Dark',
    login_welcome: 'Welcome',
    login_subtitle: 'Sign in to continue.',
    email: 'E-mail',
    credential_placeholder: 'E-mail or ID',
    password: 'Password',
    password_placeholder: 'Enter your password',
    enter: 'Sign in',
    login_hero_brand: 'ONTEST REVIEW',
    login_hero_title: 'Review essays and questions with focus, clarity, and traceability.',
    login_hero_text: 'Organize rubrics, scores, comments, and pending reviews in a workspace built for academic correction.',
    correction_brand: 'OnTest Review',
    select_institution_title: 'Choose where to record your reviews',
    select_institution_subtitle: 'Enter the institution to review essays, evaluate discursive questions, and submit scores securely.',
    access_correction_room: 'Access review workspace',
    access: 'Access',
    no_institution_available: 'No institution is available at the moment.',
    breadcrumb_home: 'Home',
    breadcrumb_processes: 'Process List',
    breadcrumb_modules: 'Modules',
    breadcrumb_essays: 'Essays',
    breadcrumb_corrected_essay: 'Corrected essay',
    breadcrumb_discursive: 'Discursive questions',
    breadcrumb_discursive_corrected: 'Corrected discursive answers',
    breadcrumb_profile: 'Profile',
    corrector_area: 'Reviewer area',
    correction_panel: 'Correction panel',
    corrector_name: 'Reviewer name',
    selective_processes: 'Selection processes',
    process_list: 'Process List',
    linked_processes: 'All selection processes linked to your user are listed here',
    process_singular: 'process',
    process_plural: 'processes',
    filter_all: 'All',
    filter_active: 'Active',
    filter_scheduled: 'Scheduled',
    filter_closed: 'Closed',
    status_active: 'Active',
    status_scheduled: 'Scheduled',
    status_closed: 'Closed',
    open_process_modules: 'Open rooms, essays, and questions for this process',
    no_process_linked: 'You are not linked to any selection process',
    no_process_status: 'No process found for this status',
    selective_process: 'Selection process',
    back: 'Back',
    start_time: 'Start time',
    end_time: 'End time',
    pending_essays: 'Pending Essays',
    pending_essays_desc: 'Rooms with essays waiting for correction',
    corrected_essays: 'Corrected Essays',
    corrected_essays_desc: 'History of completed corrections',
    discursive_questions: 'Discursive Questions',
    discursive_questions_desc: 'Pending written answers',
    corrected_discursive: 'Corrected Discursive',
    corrected_discursive_desc: 'Completed written answers',
    room: 'Room',
    corrected_count_text: '{corrected} of {total} essays corrected',
    no_room_available: 'No room available for correction',
    open: 'Open',
    review: 'Review',
    correct: 'Correct',
    search_candidate_placeholder: 'Search by candidate registration number',
    search: 'Search',
    no_essay_found: 'No essay found',
    no_discursive_found: 'No discursive question found',
    registration: 'Registration',
    question: 'Question',
    question_number: 'Question Number',
    corrected_on: 'Corrected on',
    score: 'Score',
    general_score: 'General Score',
    title: 'Title',
    prompt: 'Prompt',
    criteria: 'Criteria',
    code: 'CODE',
    criteria_label: 'CRITERIA',
    max_score: 'MAX SCORE',
    obtained_score: 'OBTAINED SCORE',
    final_score: 'Final score',
    comment: 'Comment',
    general_comment: 'General Comment',
    markings: 'Markings',
    candidate: 'Candidate',
    number: 'Number',
    aspects: 'Aspects',
    essay_counter: 'Essays {current} of {total}',
    zero_score: 'ZERO SCORE',
    loading_data: 'Loading data. Please wait.',
    loading_hint: 'Please wait while we prepare the information.',
    communication_placeholder: 'Write a general announcement to send to candidates',
  },
  Es: {
    theme_label: 'Tema',
    language_label: 'Idioma',
    theme_light: 'Claro',
    theme_dark: 'Oscuro',
    login_welcome: 'Bienvenido',
    login_subtitle: 'Inicia sesión para continuar.',
    email: 'E-mail',
    credential_placeholder: 'E-mail o documento',
    password: 'Contraseña',
    password_placeholder: 'Ingresa tu contraseña',
    enter: 'Entrar',
    login_hero_brand: 'CORRECCIÓN ONTEST',
    login_hero_title: 'Corrige redacciones y preguntas con foco, claridad y trazabilidad.',
    login_hero_text: 'Organiza criterios, notas, comentarios y pendientes en un ambiente creado para la corrección académica.',
    correction_brand: 'Corrección OnTest',
    select_institution_title: 'Elige dónde registrar tus correcciones',
    select_institution_subtitle: 'Entra en la institución para revisar redacciones, evaluar preguntas discursivas y cargar notas con seguridad.',
    access_correction_room: 'Acceder al ambiente de corrección',
    access: 'Acceder',
    no_institution_available: 'No hay instituciones disponibles en este momento.',
    breadcrumb_home: 'Inicio',
    breadcrumb_processes: 'Lista de Procesos',
    breadcrumb_modules: 'Módulos',
    breadcrumb_essays: 'Redacciones',
    breadcrumb_corrected_essay: 'Redacción corregida',
    breadcrumb_discursive: 'Preguntas discursivas',
    breadcrumb_discursive_corrected: 'Discursivas corregidas',
    breadcrumb_profile: 'Perfil',
    corrector_area: 'Área del corrector',
    correction_panel: 'Panel de corrección',
    corrector_name: 'Nombre del corrector',
    selective_processes: 'Procesos selectivos',
    process_list: 'Lista de Procesos',
    linked_processes: 'Aquí se listan todos los procesos selectivos vinculados a tu usuario',
    process_singular: 'proceso',
    process_plural: 'procesos',
    filter_all: 'Todos',
    filter_active: 'Activos',
    filter_scheduled: 'Programados',
    filter_closed: 'Cerrados',
    status_active: 'Activo',
    status_scheduled: 'Programado',
    status_closed: 'Cerrado',
    open_process_modules: 'Abrir salas, redacciones y preguntas de este proceso',
    no_process_linked: 'No estás vinculado a ningún proceso selectivo',
    no_process_status: 'No se encontró ningún proceso para este estado',
    selective_process: 'Proceso selectivo',
    back: 'Volver',
    start_time: 'Hora de inicio',
    end_time: 'Hora de cierre',
    pending_essays: 'Redacciones Pendientes',
    pending_essays_desc: 'Salas con redacciones pendientes de corrección',
    corrected_essays: 'Redacciones Corregidas',
    corrected_essays_desc: 'Historial de correcciones finalizadas',
    discursive_questions: 'Preguntas Discursivas',
    discursive_questions_desc: 'Respuestas discursivas pendientes',
    corrected_discursive: 'Discursivas Corregidas',
    corrected_discursive_desc: 'Respuestas discursivas finalizadas',
    room: 'Sala',
    corrected_count_text: '{corrected} de {total} redacciones corregidas',
    no_room_available: 'No hay salas disponibles para corrección',
    open: 'Abrir',
    review: 'Revisar',
    correct: 'Corregir',
    search_candidate_placeholder: 'Buscar por número de inscripción del candidato',
    search: 'Buscar',
    no_essay_found: 'No se encontró ninguna redacción',
    no_discursive_found: 'No se encontró ninguna pregunta discursiva',
    registration: 'Inscripción',
    question: 'Pregunta',
    question_number: 'Pregunta Número',
    corrected_on: 'Corregida el',
    score: 'Nota',
    general_score: 'Nota General',
    title: 'Título',
    prompt: 'Enunciado',
    criteria: 'Criterios',
    code: 'CÓD.',
    criteria_label: 'CRITERIOS',
    max_score: 'NOTA MÁXIMA',
    obtained_score: 'NOTA OBTENIDA',
    final_score: 'Nota final',
    comment: 'Comentario',
    general_comment: 'Comentario General',
    markings: 'Marcaciones',
    candidate: 'Candidato',
    number: 'Número',
    aspects: 'Aspectos',
    essay_counter: 'Redacciones {current} de {total}',
    zero_score: 'NOTA CERO',
    loading_data: 'Cargando datos. Por favor, espera.',
    loading_hint: 'Espera mientras preparamos la información.',
    communication_placeholder: 'Escribe un comunicado general para enviar a los candidatos',
  },
};

export const languageOptions = [
  { value: 'Pt', label: 'Português' },
  { value: 'En', label: 'English' },
  { value: 'Es', label: 'Español' },
];

export function getSelectedLanguage() {
  if (!hasStorage()) return 'Pt';
  const selectedLanguage = window.localStorage.getItem('correcao_language') || 'Pt';
  return languages[selectedLanguage] ? selectedLanguage : 'Pt';
}

export function setSelectedLanguage(language) {
  const selectedLanguage = languages[language] ? language : 'Pt';
  if (hasStorage()) {
    window.localStorage.setItem('correcao_language', selectedLanguage);
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('correcao_language_change', { detail: selectedLanguage }));
  }
  return selectedLanguage;
}

export function getLanguageTexts(language) {
  return languages[language] || languages.Pt;
}
